import { createLink } from '@tanstack/react-router';
import { createElement, forwardRef, AnchorHTMLAttributes } from 'react';
import { cn } from '@/lib/utils.ts';

const AnchorComponent = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement>>(
  (props, ref) =>
    createElement('a', {
      ...props,
      ref,
      className: cn(
        props.className,
        'font-semibold text-primary transition-colors hover:text-primary/80'
      ),
    })
);
AnchorComponent.displayName = 'AnchorComponent';

export const RouterLink = createLink(AnchorComponent);
